<template>
  <div class="item">
    <div
      class="avatar"
      :style="{
        backgroundImage: 'url(' + data.good.goodsImg + ')',
      }"
    ></div>
    <div class="content">
      <div class="title van-ellipsis">
        {{ data.good.goodsName }}
      </div>
      <div class="amount">
        <span class="prefix">¥</span>
        <span class="value">{{ data.actPrice }}</span>
      </div>
      <div class="btn van-hairline--surround" @click="clickHandle">
        选择免费拿
      </div>
    </div>

    <!--选择免费拿弹框 -->
    <chooseFreeTake ref="chooseFreeTake" @confirmFreeTake="confirmFreeTake" />
  </div>
</template>

<script>
import { selectedFreeGoods } from '@/api/freeGoods'
import chooseFreeTake from './chooseFreeTake'
export default {
  components: { chooseFreeTake },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    actThemeId: {
      type: String,
      default: null,
    },
    targetPrice: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    clickHandle() {
      // 选择免费拿弹框

      this.$refs.chooseFreeTake.open(this.data, this.targetPrice)
    },

    confirmFreeTake() {
      // 确认免费拿
      const params = {
        freeGoodsThemeId: this.actThemeId,
        dataId: this.data.dataId,
      }
      this.$store.dispatch('app/showLoading')
      selectedFreeGoods(params)
        .then((res) => {
          this.$store.dispatch('app/hideLoading')
          this.$router.push('/freeGoods?flag=1')
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
  },
}
</script>

<style lang="less" scoped>
.item {
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  overflow: hidden;
  .avatar {
    width: 100%;
    padding-top: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .content {
    text-align: left;
    padding: 8px 8px 8px;
    .title {
      font-size: 22px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
    }
    .amount {
      line-height: 24px;
      padding-top: 4px;
      .prefix {
        font-size: 16px;
        line-height: 16px;
        font-weight: 800;
        color: #333333;
      }
      .value {
        font-size: 24px;
        line-height: 24px;
        font-weight: 800;
        color: #333333;
      }
    }
    .btn {
      color: #e82035;
      font-size: 20px;
      text-align: center;
      padding: 5px 0;
      margin-top: 10px;
      &::after {
        border-color: #e82035;
        border-radius: 12px;
      }
    }
  }
}
</style>
